<script>
    import { onMount } from 'svelte';
    import { on } from 'svelte/events';
    import { ApiClient } from '../../ApiClient.js';

    /** @type {string} */
    let mediaUrl = $state();
    /** @type {{ status: 'idle' | 'loading' | 'success' | 'error' | 'unsupported', data?: object, error?: string }} */
    let subtitles = $state({ status: 'idle' });
    /** @type {boolean} */
    let visible = $derived(mediaUrl);

    const mapSubtitleResponse = (err, data) => {
        if (err && err.status === 422) {
            return { status: 'unsupported', error: err.message };
        } else if (err && err.status === 404) {
            return { status: 'idle' };
        } else if (err) {
            return { status: 'error', error: err.message };
        } else {
            return { status: 'success', data: { ...data } };
        }
    };

    onMount(() => {
        const cleanup1 = on(document.getElementById('mediaurl'), 'input', (event) => {
            mediaUrl = event.target.value.trim();

            subtitles = { status: 'loading' };
            ApiClient.tryFindSubtitles(mediaUrl).then(({ error, data }) => {
                subtitles = mapSubtitleResponse(error, data);
            });
        });
        // some jquery methods (like .val(''))
        // don't trigger any events so we hide panel as a workaround
        // TODO(rite): think of a better way
        const cleanup2 = on(document.getElementById('queue_next'), 'click', () => (visible = false));
        const cleanup3 = on(document.getElementById('queue_end'), 'click', () => (visible = false));

        return () => {
            cleanup1();
            cleanup2();
            cleanup3();
        };
    });

    const getStatusText = (subtitles) => {
        switch (subtitles.status) {
            case 'loading':
                return 'Loading...';
            case 'success': {
                const { fileName, userName, createdAt } = subtitles.data;
                const user = userName || 'Unknown user';
                const date =
                    createdAt && !isNaN(new Date(createdAt).getTime())
                        ? new Date(createdAt).toLocaleString()
                        : 'Unknown date';

                return `Added: ${fileName} (${user},${date})`;
            }
            case 'error':
                return `Error: ${subtitles.error}`;
            case 'unsupported':
                return `Subtitles for this media are not supported: ${subtitles.error}`;
            default:
                return 'Add subtitles to the media file';
        }
    };

    /** @param {Event & { currentTarget: EventTarget & HTMLInputElement } & { target: HTMLInputElement } & InputEvent} event onchange event*/
    const onchange = (event) => {
        const files = event.target.files;
        if (files.length === 0) {
            return;
        }

        subtitles = { status: 'loading' };
        const file = files[0];
        ApiClient.uploadSubtitles(mediaUrl, file).then(({ error, data }) => {
            subtitles = mapSubtitleResponse(error, data);
        });

        event.target.files = new DataTransfer().files; // Clear file input
    };
</script>

{#if visible}
    <div class="subs-panel">
        <div class={subtitles.status}>
            {#if subtitles.status !== 'unsupported'}
                <label class="upload-btn" title="Add subtitles">
                    <span class="glyphicon">+</span>
                    <span
                        >{subtitles.status === 'loading'
                            ? 'Adding...'
                            : subtitles.status === 'success'
                              ? 'Preupload from file'
                              : 'Upload from file'}
                    </span>
                    <input class="file-input" accept=".ass" disabled={!visible} {onchange} type="file" />
                </label>
            {/if}
            {#if subtitles.status === 'success'}
                <a class={subtitles.status} href={subtitles.data.subtitleUrl}> {getStatusText(subtitles)}</a>
            {:else}
                {getStatusText(subtitles)}
            {/if}
        </div>
    </div>
{/if}

<style>
    .subs-panel {
        margin: 10px 0;
        padding: 10px 15px;
        background-color: rgba(0, 10, 20, 0.6);
        border: 1px solid rgba(85, 85, 85, 0.4);
        border-radius: 4px;
    }

    .subs-title {
        margin-bottom: 10px;
    }

    .subs-text {
        color: #d8b692;
        font-size: 12px;
        font-style: italic;
        margin-bottom: 8px;
    }

    .error {
        color: #ff6b6b;
    }

    .success {
        color: #51cf66;
    }

    .unsupported {
        color: #ff8c00;
    }

    .file-input {
        display: none;
    }

    .upload-btn {
        display: inline-block;
        padding: 4px 8px;
        background-color: rgba(85, 85, 85, 0.4);
        border: 1px solid rgba(255, 255, 255, 0.2);
        border-radius: 3px;
        color: #fff;
        cursor: pointer;
        font-size: 11px;
        text-decoration: none;
    }

    .upload-btn:hover {
        background-color: rgba(85, 85, 85, 0.6);
    }

    .upload-btn:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }

    .glyphicon {
        margin-right: 4px;
    }
</style>
